import PropTypes from 'prop-types';
import { Flyout } from '@celltrak/ui-components';

import { useAction } from '../../../Common/hooks';
import { hideFlyout } from '../../../Dashboard/actions';
import AgenciesCreationTabs from '../AgenciesCreationTabs';
import { createAgencies } from '../../constants';

import styles from './AgenciesCreation.module.scss';

const AgenciesCreationFlyout = ({ show }) => {
  const dispatchHideFlyout = useAction(hideFlyout);

  const handleOnCloseFlyout = () => {
    dispatchHideFlyout();
  };

  return (
    <Flyout
      show={show}
      className={styles.agenciesCreationFlyout}
      heading="Agencies"
      onCloseClick={() => handleOnCloseFlyout()}
      title={createAgencies}
    >
      <AgenciesCreationTabs />
    </Flyout>
  );
};

AgenciesCreationFlyout.propTypes = {
  show: PropTypes.bool,
};

AgenciesCreationFlyout.defaultProps = {
  show: '',
};

export default AgenciesCreationFlyout;
